import { useFormikContext } from 'formik';

import { Box } from '@hivebrite/design-system/Box';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

import { Section } from './Section';
import { PARENT } from '../constants';
import { type FormValues, type PublicationInputs } from '../types';

export const PublicationInfo = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();

  const inputs: PublicationInputs = [
    {
      id: 'public',
      label: s__('JobForm|Public'),
      name: 'public',
      value: values.public,
    },
    {
      id: 'pinned_on_index_page',
      label:
        values.parent_type === PARENT.GROUP
          ? s__('JobForm|Highlight from related Group Opportunities list(s)')
          : s__(
              'JobForm|Highlight from Opportunities list(s) (Global and any related Groups)',
            ),
      name: 'pinned_on_index_page',
      value: values.pinned_on_index_page,
    },
    values.parent_type === PARENT.NETWORK && {
      id: 'pinned',
      label: s__('JobForm|Pinned on the global Live feed'),
      name: 'pinned',
      value: values.pinned,
    },
  ].filter(Boolean as any);

  return (
    <Section title={s__('JobForm|Publication')}>
      <Grid mx={0} rowGap={0}>
        <Row>
          <Col>
            {inputs.map((input) => (
              <Box display="block" pb={6} key={input.id}>
                <CheckboxInput
                  id={input.id}
                  name={input.name}
                  label={input.label}
                  value={input.value}
                  onChange={() => setFieldValue(input.name, !input.value)}
                />
              </Box>
            ))}
          </Col>
        </Row>
      </Grid>
    </Section>
  );
};
